import React from "react";
import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";

const SECTIONS = [
  { h: "1. What Are Cookies?", p: "Cookies are small text files stored on your device when you visit KalamPrime. Similar technologies like local storage let the Service remember you and how you use it." },
  { h: "2. Cookies We Use", p: "Essential: secure session cookies and a local login token that keep you signed in and protect your account and the Kids PIN. Preferences: your billing toggle, Kids mode state, and language filters. Analytics: aggregated, anonymised usage that helps us improve KalamPrime. We do not use cookies to sell your personal data." },
  { h: "3. Why We Use Them", p: "To keep you logged in, remember your My List and Continue Watching, maintain the PIN-protected Kids experience, secure payments, and understand which features viewers enjoy so we can make the Service better." },
  { h: "4. Managing Cookies", p: "You can control or delete cookies through your browser settings, and clear local storage at any time. Note that blocking essential cookies will sign you out and may stop parts of KalamPrime from working, including staying inside the Kids safe zone." },
  { h: "5. Third-Party Services", p: "Our payment partner and hosting/analytics providers may set their own cookies when you interact with those features. Their use of cookies is governed by their own policies." },
  { h: "6. Updates", p: "We may update this Cookies Notice and will post the revised version here with a new date." },
];

export default function Cookies() {
  return (
    <Layout>
      <div className="pt-28 px-4 md:px-12 pb-16 max-w-3xl mx-auto" data-testid="cookies-page">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white fade-up">Cookies Notice</h1>
        <p className="text-slate-400 mt-2">KalamPrime, a brand by Ishukart. Last updated {new Date().getFullYear()}.</p>
        <div className="mt-8 space-y-7">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-lg font-bold text-white">{s.h}</h2>
              <p className="text-slate-300 leading-relaxed mt-2 text-sm sm:text-base">{s.p}</p>
            </section>
          ))}
        </div>
        <p className="text-sm text-slate-400 mt-10">
          See also our <Link to="/privacy" className="text-[var(--nik-glow)] hover:underline">Privacy Policy</Link> and{" "}
          <Link to="/terms" className="text-[var(--nik-glow)] hover:underline">Terms of Use</Link>.
        </p>
      </div>
    </Layout>
  );
}
